export const BUILD_VERSION = '5309a4811ef97a4ef1efd5ae7bdbe3bdc1678df2';
